const __request = require(`./__request/__request_contentType_form`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/web/common/userBuyer/updateBuyer',
        data: data
    }
    return __request(pParameter)
}
export default request